export const Description = ({ description }: { description: string }) => {
	return (
		<div
			className="text-xs"
			dangerouslySetInnerHTML={{
				__html: description,
			}}
		/>
	)
}
